export class Profile {
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    phone: number;
}